import React from "react"
import AsyncSelect from "react-select"
const assignmentOfWorkTemplate = {
  sample: null,
  cad: null,
  fabric: null,
  trim: null,
  pattern: null,
  cutting: null,
  sewing: null,
  garmentTechnologist: null,
  embellishment: null,
  embroidery: null,
  wash: null,
  dispatch: null,
  qc: null,//GRADING
  marker: null,
  costing: null,
  signOff: null
}

export default function AssigmentOfWork(props) {
  return (
    <div className="row m-0">
      <div class="col-md-12 text-left">
        <h6 className="text-color-green font-weight-bold pb-3 ml-5">
          {props.moduleName}
        </h6>
      </div>
      {Object.keys(assignmentOfWorkTemplate).map((data, index) => {
        return (
          <div className="col-md-6 mb-3" key={index}>
            <div
              className="d-flex justify-content-between align-items-center"
              onFocus={() => props.getAssign("")}
            >
              <div className="pr-3 text-right mx-w-35">
                <h6 className="text-uppercase">
                  {data === "garmentTechnologist"
                    ? "garment Technologist"
                    : data === "qc" ? 'GRADING' : data==="cad"?"3D/Cad":[data]}
                </h6>
              </div>
              <div className="mx-w">
                <div class="custom-async-select">
                  <AsyncSelect
                    options={props.employeesOption}
                    name={[data]}
                    //value={props.assignmentOfWork[data]}
                    value={
                      props.assignmentOfWork[data] && props.searchOption.find(
                        option => option.value === props.assignmentOfWork[data]
                      ) || null
                    }
                    onChange={val =>
                      props.changeAssign(data, val, index, props.moduleName)
                    }//here val is getting the object from the search emp options and send whole object to the state 
                    // onFocus={() => props.getAssign("")}
                    // autoFocus={(index == 0 && true) || props.action == "view"}
                    onInputChange={props.getAssign}
                    disabled={props.disabled}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Customer/AssignmentOfWork/index.js